import React from 'react';
import { Heading, MemberIcon } from '@/components';
import { formatTimeRange } from '@/lib/utils';
import { formatEventDate } from '@/lib/events';
import { EventDates } from '@/types/EventInterface';

interface EventInfoProps {
  location?: string;
  recommendedAges?: string;
  isMemberOnly?: boolean;
  eventDate?: EventDates;
  children?: React.ReactNode;
}

const EventInfo: React.FC<EventInfoProps> = ({
  location,
  recommendedAges,
  isMemberOnly,
  eventDate,
  children,
}) => {
  return (
    <div className='mx-auto flex max-w-screen-xl flex-col px-5 py-8 md:p-[50px]'>
      <div className='pb-6 last:pb-0 md:pb-9'>
        <Heading title='details' />
        <div>
          {isMemberOnly && (
            <div className='mb-2 flex items-center sm:mb-3'>
              <MemberIcon
                width={24}
                height={24}
              />
              <span className='ml-2 text-xl font-normal leading-7 sm:ml-3 sm:text-lg'>
                member event
              </span>
            </div>
          )}
          {eventDate?.frequency && (
            <>
              <div className='mb-2 flex items-center sm:mb-3'>
                <img
                  src='/images/calender-icon.svg'
                  className='mr-2 h-6 w-6 sm:mr-3'
                  alt='Calendar Icon'
                />
                <span className='text-xl font-normal leading-7 sm:text-lg'>
                  {formatEventDate(eventDate.frequency.startDate)}
                </span>
              </div>
              <div className='mb-2 flex items-center sm:mb-3'>
                <img
                  src='/images/time-icon.svg'
                  className='mr-2 h-6 w-6 sm:mr-3'
                  alt='Time Icon'
                />
                <span className='text-xl font-normal leading-7 sm:text-lg'>
                  {formatTimeRange(eventDate.frequency.startDate, eventDate.frequency.endDate)} EST
                </span>
              </div>
            </>
          )}
          {location && (
            <div className='mb-2 flex items-center sm:mb-3'>
              <img
                src='/images/location-icon.svg'
                className='mr-2 h-6 w-6 sm:mr-3'
                alt='Location Icon'
              />
              <span className='text-xl font-normal leading-7 sm:text-lg'>{location}</span>
            </div>
          )}
          {recommendedAges && (
            <div className='mb-2 flex items-center sm:mb-3'>
              <img
                src='/images/ages-icon.svg'
                className='mr-2 h-6 w-6 sm:mr-3'
                alt='Ages Icon'
              />
              <span className='text-xl font-normal lowercase leading-7 sm:text-lg'>
                recommended ages: {recommendedAges}
              </span>
            </div>
          )}
          {children}
        </div>
      </div>
    </div>
  );
};

export default EventInfo;
